import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const VARIANT_CLASS = {
    ghost: 'btn btn--ghost btn--icon-only',
    secondary: 'btn btn--icon-only',
    danger: 'btn btn--danger btn--icon-only',
};
const SIZE_PX = { sm: 24, md: 30 };
/** Canonical icon-only button. Always supplies an accessible label. */
export const IconButton = forwardRef(function IconButton({ label, size = 'md', variant = 'ghost', className = '', children, type, style, ...rest }, ref) {
    const dim = SIZE_PX[size];
    return (_jsx("button", { ref: ref, type: type ?? 'button', title: label, "aria-label": label, className: `${VARIANT_CLASS[variant]}${className ? ` ${className}` : ''}`, style: { width: dim, height: dim, padding: 0, ...style }, ...rest, children: children }));
});
//# sourceMappingURL=IconButton.js.map